import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  Navigate,
  useParams,
  useNavigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./styles/App.css";
import { isEmpty } from "./functions/isEmpty";
import useFetch from "./functions/useFetch";

import Home from "./screens/Home";
import useScreenType from "./functions/useScreenType";
import { LanguageProvider } from "./contexts/LanguageContext";
import Imprint from "./screens/Imprint";

const developerMode = true;

export default function App() {
  let apiURL = "https://cloud.meternityai.com";
  if (developerMode) {
    apiURL = "https://cloud.meternityai.com";
  }

  /* Auth Token */
  const [authToken, setAuthToken] = useState("");

  /* screen */
  const isMobile = useScreenType();

  /* userdata */
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [userID, setUserID] = useState(null);

  // neuen nutzer anlegen
  useEffect(async () => {
    if (isEmpty(userID)) {
      const localData = localStorage.getItem("@stoicmeternity");
      if (!isEmpty(localData)) {
        setUserID(JSON.parse(localData));
      } else {
        const resa = await fetch(`${apiURL}/users/create_new_user.php`, {
          method: "GET",
          headers: {
            //   Authorization: `Bearer ${authToken?.JWT}`,
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          //    body: JSON.stringify({            }),
        });
        await resa.text().then((value) => saveNewUser(value));
      }
    }
  }, [userID]);

  const saveNewUser = (newUserID) => {
    console.log(newUserID);
    setUserID(newUserID);
    localStorage.setItem("@stoicmeternity", newUserID);
  };

  return (
    <div className="app">
      <LanguageProvider>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  apiURL={apiURL}
                  userID={userID}
                  isMobile={isMobile}
                  setUserID={setUserID}
                />
              }
            />
            <Route
              path="/imprint"
              element={
                <Imprint apiURL={apiURL} userID={userID} isMobile={isMobile} />
              }
            />
          </Routes>
          <></>
        </Router>
      </LanguageProvider>
    </div>
  );
}
